import React, { useState, useEffect, useRef } from 'react';
import HrUsersHeader from './HrUsersHeader/HrUsersHeader';
import classes from './style/HrUsers.module.css';
import { UsersProps } from '../../types/UsersType';
import { ApiCenter } from '../api/ApiCenter';
import { Button } from 'antd';
import HrUsersTable from './HrUsersTable/HrUsersTable';
import { UI_Footer } from '../../Core/Core';

const HrUsers = () => {
  const [data, setData] = useState<UsersProps>();
  const Apistart = new ApiCenter();
  const prevValueRef = useRef<string>();
  const timerRef = useRef<NodeJS.Timeout | undefined>();
  const [choiceUser, setChoiceUser] = useState<React.Key[]>([]);
  const [tableKey, setTableKey] = useState(0);
  const [filterTests, setFilterTests] = useState<{
    category_id: number;
    name: string;
  }>({
    category_id: 1,
    name: '',
  });
  const constructLink = () => {
    const baseUrl = 'hr/user';
    let link = baseUrl;

    switch (filterTests.category_id) {
      case 1:
        break;
      default:
        link += `?category_id=${filterTests.category_id}`;
        break;
    }

    if (filterTests.name !== '') {
      if (filterTests.category_id !== 1) {
        link += `&name=${filterTests.name}`;
      } else {
        link += `?name=${filterTests.name}`;
      }
    }

    return link;
  };

  const fetchUsers = async (link: string) => {
    try {
      const response = await Apistart.GET_API(link, 'GET');
      if (response.success) {
        setData(response.data);
      } else {
        // eslint-disable-next-line no-console
        console.log('Что-то пошло не так!');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  const sendUsersForAttestation = () => {
    const selectedUsers = { user_ids: choiceUser };
    Apistart.GET_API('hr/attestation', 'POST', selectedUsers).then((response: UsersProps) => {
      if (response.success) {
        setChoiceUser([]);
        setTableKey((prevKey) => prevKey + 1);
      } else {
        alert(response.message);
      }
    });
  };

  const handleChange = (value: number) => {
    setFilterTests(() => ({ ...filterTests, category_id: value }));
  };
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.value !== prevValueRef.current) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      prevValueRef.current = event.currentTarget.value;
      if (prevValueRef.current) {
        timerRef.current = setTimeout(() => {
          setFilterTests({
            ...filterTests,
            name: prevValueRef.current ? prevValueRef.current : event?.currentTarget?.value,
          });
        }, 800);
      } else {
        setFilterTests({ ...filterTests, name: '' });
      }
    }
  };
  const reset = () => {
    setFilterTests({ category_id: 1, name: '' });
    setChoiceUser([]);
    setTableKey((prevKey) => prevKey + 1);
  };
  const choiceUserSwitch = (hasSelected: React.Key[]) => {
    setChoiceUser(hasSelected);
  };
  const getSelectUsers = () => {
    sendUsersForAttestation();
  };
  useEffect(() => {
    fetchUsers(constructLink());
  }, [filterTests]);
  return (
    <>
      <h1 className={classes.HeaderTitle}>Список пользоватей</h1>
      {data ? (
        <>
          <HrUsersHeader
            handleChange={handleChange}
            handleSearch={handleSearch}
            reset={reset}
            categories={data.categories}
          />
          <HrUsersTable
            key={tableKey}
            data={data.users}
            choiceUserSwitch={choiceUserSwitch}
            selectUser={choiceUser}
          />
          <UI_Footer classStyle="end">
            {choiceUser.length > 0 && <Button onClick={reset}>Отменить выбор</Button>}
            <Button disabled={choiceUser.length < 1} type="primary" onClick={getSelectUsers}>
              Назначить аттестацию
            </Button>
          </UI_Footer>
        </>
      ) : (
        <>Загрузка</>
      )}
    </>
  );
};

export default HrUsers;
